import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import type { Role } from '../../shared/types'
import { useAuth } from '../lib/auth'

// Gates a route on authentication and (optionally) role. Redirects to /login
// when signed out, or to the caller's home when the role doesn't match.
export function ProtectedRoute({
  roles,
  children,
}: {
  roles?: Role[]
  children: ReactNode
}) {
  const { user, loading, activeCompany } = useAuth()

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh', color: 'var(--gray)' }}>
        Loading…
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  if (roles && !roles.includes(user.role)) {
    // A super_admin who has entered a company via the switcher may use the
    // company portal (scoped by X-Company-Id).
    if (user.role === 'super_admin' && activeCompany && roles.includes('company_admin')) {
      return <>{children}</>
    }
    return <Navigate to={user.role === 'super_admin' ? '/admin' : '/app'} replace />
  }
  return <>{children}</>
}
